export default __webpack_public_path__ + "static/media/instagram.852ea7e4.jpg";